module.exports = __webpack_public_path__ + "static/img/XC50.9d0bdf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XC50.png
// module id = /yyT
// module chunks = 2